export default __webpack_public_path__ + "static/media/eye.9158612a.svg";